export const FORM_INPUT_CLASS =
    "h-8 p-0 pl-1.5 m-0 text-sm w-full bg-transparent outline-none border-0 shadow-none";

export const FORM_LABEL_CLASS = "text-[#121212] w-40";

export const FORM_ITEM_CLASS = "!mb-0 w-full";

export const SELECT_CONFIG = {
    components: {
        Select: {
            activeOutlineColor: "transparent",
        },
    },
};

export const FORM_SELECT_STYLE = {
    width: "100%",
    fontSize: "0.875rem",
};
export const FIELD_LABEL_CLASS = "text-[#acacb9] w-40 align-top";

export const TAB_ACTIVE_CLASS = "listact text-[#5d5dff]";

export const TAB_INACTIVE_CLASS = "cursor-pointer";
